import React, { ReactElement, CSSProperties } from 'react';

import { ProviderType } from '@api/v3';
import Typography from '@components/Typography';
import CustomIcon from '@components/utils/CustomIcon';
import arrowRight from '@assets/icons/icon-arrow-right.svg';
import arrowDown from '@assets/icons/icon-arrow-down.svg';
import { useDevice } from '@contexts/device';

import {
  Container,
  Navigation,
  NavigationText,
  Wrapper,
  Title,
  Arrow,
  Children,
} from './styled';

export enum ArrowAlign {
  NO_ARROW = '0',
  UP_DOWN = '1',
  FIXED_RIGHT = '2',
}

interface ShowMoreCardProps {
  title: string;
  navigationText: string | ReactElement;
  onNavigate?: () => void;
  isShowMore?: boolean;
  arrowAlign?: ArrowAlign;
  containerStyle?: CSSProperties;
  isShowAll?: boolean;
  provider?: ProviderType;
}

const ShowMoreCard = ({
  title,
  navigationText,
  onNavigate,
  children,
  isShowMore = true,
  arrowAlign = ArrowAlign.NO_ARROW,
  containerStyle,
  isShowAll,
  provider,
}: React.PropsWithChildren<ShowMoreCardProps>) => {
  const { isMobile } = useDevice();

  return (
    <Container {...(containerStyle ? { style: containerStyle } : {})}>
      <Wrapper>
        <Title>
          <Typography
            variant={isMobile ? 'caption1' : 'Title4'}
            color='D400'
            weight='Bold'
          >
            {title}
          </Typography>
        </Title>
        {isMobile && onNavigate ? (
          <Navigation>
            {provider === ProviderType.SETUR_LOCAL_HOTEL ? (
              <NavigationText onClick={onNavigate}>
                <Typography variant='caption2' color='BR300' weight='Bold'>
                  {navigationText}
                </Typography>
                {arrowAlign === ArrowAlign.NO_ARROW ? null : (
                  <Arrow>
                    <CustomIcon
                      isOpen={ArrowAlign.UP_DOWN && isShowMore}
                      icon={
                        arrowAlign === ArrowAlign.UP_DOWN
                          ? arrowDown
                          : arrowRight
                      }
                      fontSize={20}
                    />
                  </Arrow>
                )}
              </NavigationText>
            ) : null}
          </Navigation>
        ) : null}
      </Wrapper>
      {isShowAll ? (
        <>
          {!isMobile && onNavigate ? (
            <Navigation>
              {provider === ProviderType.SETUR_LOCAL_HOTEL ? (
                <NavigationText onClick={onNavigate}>
                  <Typography variant='caption2' color='BR300' weight='Bold'>
                    {navigationText}
                  </Typography>
                  {arrowAlign === ArrowAlign.NO_ARROW ? null : (
                    <Arrow>
                      <CustomIcon
                        isOpen={ArrowAlign.UP_DOWN && isShowMore}
                        icon={
                          arrowAlign === ArrowAlign.UP_DOWN
                            ? arrowDown
                            : arrowRight
                        }
                        fontSize={20}
                      />
                    </Arrow>
                  )}
                </NavigationText>
              ) : null}
            </Navigation>
          ) : null}
          <Children>{children}</Children>
        </>
      ) : (
        <>
          <Children>{children}</Children>
          {!isMobile && onNavigate ? (
            <Navigation>
              {provider === ProviderType.SETUR_LOCAL_HOTEL ? (
                <NavigationText onClick={onNavigate}>
                  <Typography variant='caption2' color='BR300' weight='Bold'>
                    {navigationText}
                  </Typography>
                  {arrowAlign === ArrowAlign.NO_ARROW ? null : (
                    <Arrow>
                      <CustomIcon
                        isOpen={ArrowAlign.UP_DOWN && isShowMore}
                        icon={
                          arrowAlign === ArrowAlign.UP_DOWN
                            ? arrowDown
                            : arrowRight
                        }
                        fontSize={20}
                      />
                    </Arrow>
                  )}
                </NavigationText>
              ) : null}
            </Navigation>
          ) : null}
        </>
      )}
    </Container>
  );
};

export default ShowMoreCard;
